import React, { useState, useRef, FC } from 'react';
import { css } from '@emotion/css';

const HeaderMenu: FC<{ path: string}> = ({ path }) => {
  const [active, setActive] = useState(false);
  const [height, setHeight] = useState(0);
  const subWrapBox = useRef(null);

  const open = () => {
    setActive((prev) => {
      if (prev) {
        setHeight(0);
        return false;
      }
      setHeight(subWrapBox.current.scrollHeight);
      return true;
    });
  };

  const styles = {
    nav: css({
      position: 'relative',
      zIndex: 20,
    }),

    navBg: css({
      position: 'absolute',
      width: '100%',
      backgroundColor: '#47AFFE',
      zIndex: 0,
      transition: 'height .25s',
    }),

    header: css({
      position: 'relative',
      maxWidth: 1470,
      padding: '15px',
      margin: '0 auto',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',

      '@media (min-width: 768px)': {
        padding: '25px 15px 20px',
      },
    }),

    logo: css({
      width: 190,
      margin: '0 10px 0 0',

      '@media (min-width: 768px)': {
        width: 436,
      },
    }),

    btnWrap: css({
      width: 110,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      backgroundColor: '#47AFFE',
      padding: 4,
      transition: 'bacground-color .25s',
      flexShrink: 0,

      '@media (min-width: 768px)': {
        width: 285,
      },
    }),

    btnWrapActive: css({
      backgroundColor: '#fff !important',
    }),

    entry: css({
      color: '#fff',
      fontWeight: 'bold',
      padding: '0 0 0 10px',
      fontSize: '1rem',
      transition: 'color .25s',

      '@media (min-width: 768px)': {
        padding: '0 20px',
        fontSize: '3.2rem',
      },
    }),

    entryActive: css({
      color: '#47AFFE !important',
    }),

    btn: css({
      display: 'flex',
      width: 40,
      height: 40,
      flexShrink: 0,
      border: 0,
      backgroundColor: '#fff',
      flexDirection: 'column',
      justifyContent: 'space-between',
      padding: '9px 8px',
      cursor: 'pointer',
      transition: 'bacground-color .25s',

      '@media (min-width: 768px)': {
        width: 53,
        height: 53,
        padding: '14px 12px',
      },
    }),

    btnActive: css({
      backgroundColor: '#47AFFE !important',
    }),

    btnItem: css({
      backgroundColor: '#47AFFE',
      height: 3,
      width: '100%',
      transition: 'bacground-color .25s, opacity .25s, transform .25s',
    }),

    btnItemActive: css({
      backgroundColor: '#fff !important',

      '&:nth-of-type(1)': {
        transform: 'translateY(10px) rotate(-315deg)',

        '@media (min-width: 768px)': {
          transform: 'translateY(11px) rotate(-315deg)',
        },
      },

      '&:nth-of-type(2)': {
        opacity: 0,
      },

      '&:nth-of-type(3)': {
        transform: 'translateY(-9px) rotate(315deg)',

        '@media (min-width: 768px)': {
          transform: 'translateY(-11px) rotate(315deg)',
        },
      },
    }),

    subWrapBox: css({
      transition: 'height .25s',
      overflow: 'hidden',
      position: 'absolute',
      width: '100%',
    }),

    subWrap: css({
      padding: '30px 0',

      '@media (min-width: 768px)': {
        padding: '60px 0 70px',
      },
    }),

    sub: css({
      maxWidth: 1470,
      padding: '0 15px',
      margin: '0 auto',

      '@media (min-width: 768px)': {
        display: 'flex',
        justifyContent: 'space-between',
      },
    }),

    subItemTop: css({
      margin: '0 0 20px',

      '@media (min-width: 768px)': {
        margin: 0,
        width: '19%',
      },
    }),

    subTop: css({
      fontSize: '1.8rem',
      lineHeight: 1.2,
      textDecoration: 'none',
      color: '#fff',

      '@media (min-width: 768px)': {
        fontSize: '2.3rem',
      },
    }),

    subItem: css({
      margin: '0 0 20px',

      '@media (min-width: 768px)': {
        margin: 0,
        width: '27%',
        borderLeft: '1px solid #9ED5FF',
        padding: '10px 15px 10px 20px',
      },
    }),

    subList: css({

    }),

    subListItem: css({

      '&:not(:last-of-type)': {
        margin: '0 0 20px',
      },
    }),

    subListLink: css({
      fontSize: '1.6rem',
      lineHeight: 1.2,
      textDecoration: 'none',
      color: '#fff',

      '@media (min-width: 768px)': {
        fontSize: '2rem',
      },
    }),
  };

  return (
    <nav className={styles.nav}>
      <div className={styles.navBg} style={{ height: `${height ? height + 106 : 0}px` }} />
      <div className={styles.header}>
        <h1 className={styles.logo}>
          <a href={`${path}./.`}>
            {
              active
                ? <img src={`${path}images/logo-active.svg`} alt="成豊建設株式会社 RECRUIT" />
                : <img src={`${path}images/logo.svg`} alt="成豊建設株式会社 RECRUIT" />
            }
          </a>
        </h1>
        <div className={active ? `${styles.btnWrap} ${styles.btnWrapActive}` : styles.btnWrap}>
          <span className={active ? `${styles.entry} ${styles.entryActive}` : styles.entry}>ENTRY</span>
          <button type="button" className={active ? `${styles.btn} ${styles.btnActive}` : styles.btn} onClick={open}>
            <span className={active ? `${styles.btnItem} ${styles.btnItemActive}` : styles.btnItem} />
            <span className={active ? `${styles.btnItem} ${styles.btnItemActive}` : styles.btnItem} />
            <span className={active ? `${styles.btnItem} ${styles.btnItemActive}` : styles.btnItem} />
          </button>
        </div>
      </div>
      <div className={styles.subWrapBox} style={{ height: `${height}px` }} ref={subWrapBox}>
        <div className={styles.subWrap}>
          <div className={styles.sub}>
            <div className={styles.subItemTop}>
              <a href={`${path}./.`} className={styles.subTop}>RECRUIT<br />トップページ</a>
            </div>
            <div className={styles.subItem}>
              <ul className={styles.subList}>
                <li className={styles.subListItem}>
                  <a href={`${path}desclist.html`} className={styles.subListLink}>募集要項</a>
                </li>
                <li className={styles.subListItem}>
                  <a href={`${path}work.html`} className={styles.subListLink}>働きやすさ・待遇</a>
                </li>
                <li className={styles.subListItem}>
                  <a href={`${path}education.html`} className={styles.subListLink}>社員教育・キャリアパス</a>
                </li>
                <li className={styles.subListItem}>
                  <a href={`${path}../business/story.html`} className={styles.subListLink}>プロジェクトストーリー</a>
                </li>
              </ul>
            </div>
            <div className={styles.subItem}>
              <ul className={styles.subList}>
                <li className={styles.subListItem}>
                  <a href={`${path}interviewlist.html`} className={styles.subListLink}>先輩インタビュー</a>
                </li>
                <li className={styles.subListItem}>
                  <a href={`${path}tunnel.html`} className={styles.subListLink}>知って！トンネルのこと</a>
                </li>
                <li className={styles.subListItem}>
                  <a href={`${path}faq.html`} className={styles.subListLink}>採用Q&A</a>
                </li>
                <li className={styles.subListItem}>
                  <a href={`${path}school.html`} className={styles.subListLink}>出身校一覧</a>
                </li>
              </ul>
            </div>
            <div className={styles.subItem}>
              <ul className={styles.subList}>
                <li className={styles.subListItem}>
                  <a href={`${path}.././.`} className={styles.subListLink}>コーポレートサイト</a>
                </li>
                <li className={styles.subListItem}>
                  <a href={`${path}../privacy.html`} className={styles.subListLink}>プライバシーポリシー</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default HeaderMenu;
